// src/services/industriesService.js
import apiClient from './apiClient.js'

export const industriesService = {
    getIndustries(params = {}) {
        return apiClient.get('/industries', { params })
    },

    getIndustryBySlug(slug) {
        return apiClient.get(`/industries/slug/${slug}`)
    },

    createIndustry(data) {
        return apiClient.post('/industries', data)
    },

    updateIndustry(id, data) {
        return apiClient.put(`/industries/${id}`, data)
    },

    deleteIndustry(id) {
        return apiClient.delete(`/industries/${id}`)
    },
}